import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Card,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
//   import {
//     getcategorysDetails,
//     getCategoryList
//     // updateActivationStatus,
//   } from "./categoryapiFunctions";
import { getCategoryList } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import AddCategory from "./AddCategory";
import errorImage from "../../../assets/images/food.png"

const CategoryList = () => {
    const [categoryData, setcategoryData] = useState([]);
    const [totalPages, setTotalPages] = useState();
    const [pageSize, setPageSize] = useState(9);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [dataSource, setDataSource] = useState([]);
    // const [totalPage, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from;
    console.log(from);

    function FetchcategorysDetails(currentPage) {
        getCategoryList(`?page=${currentPage}&limit=${pageSize}`)
            // `isActive=1&isApproved=${approved}&isRejected=${rejected}&request_name=${searchTerm}&page=${currentPage}`
            .then((response) => {
                setIsLoading(true);
                if (response.status == "success") {
                    setDataSource(response.data?.categories);
                    setCurrentPage(response.data?.currentPage);
                    setTotalPages(response.data?.totalPages);
                    // setTotalPages(response.data?.pagination.totalPages || 0);
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                console.log("error", err);
                setIsLoading(false);
            });
    }
    // function changeActiveStatus(checked, record) {
    //   console.log(checked, record);
    //   const isDeleteAction = checked === undefined;

    //   let payload = {
    //     name: record.name,
    //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
    //     is_deleted: isDeleteAction ? "0" : "1",
    //   };

    //   updateActivationStatus(payload, record.id)
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         const updatedcategoryTable = categoryData.map((item) =>
    //           item.id === record.id
    //             ? {
    //                 ...item,
    //                 is_active: isDeleteAction
    //                   ? item.is_active
    //                   : payload.is_active,
    //               }
    //             : item
    //         );
    //         setcategoryData(updatedcategoryTable);
    //         FetchcategorysDetails(currentPage);
    //         message.open(
    //           messageConfiguration(
    //             "success",
    //             isDeleteAction
    //               ? "Category deleted successfully."
    //               : response.message,
    //             3
    //           )
    //         );
    //         if (!isDeleteAction) {
    //           FetchcategorysDetails(currentPage);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       message.open(
    //         messageConfiguration(
    //           "error",
    //           isDeleteAction
    //             ? "Failed to delete category."
    //             : "Failed to update status.",
    //           3
    //         )
    //       );
    //     });
    // }
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };
    ////////////////Solve/////////////////
    const mainFun = (grid) => {
        let row = 2;
        let col = 2;
        let arr = Array.from({ length: row }, () => Array(col).fill(0))

        console.log(arr);

    }

    const grid = [
        [1, 2],
        [3, 4],
    ];;

    console.log(mainFun(grid))
    ////////////////Solve/////////////////
    useEffect(() => {
        FetchcategorysDetails(currentPage);
    }, [currentPage, searchTerm]);

    const handleErrorImage = (e) => {
        e.target.src = errorImage; // Set the source to the imported image
    };

    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };
    const columnReports = [
        {
            title: "User Name",
            dataIndex: "username",
            key: "username",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {record.username?.toUpperCase() ?? "--"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.email ?? "--"}</p>
                    </>
                );
            },
        },
        {
            title: "Contact",
            dataIndex: "phone",
            key: "phone",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.phone ?? "--"}</p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "isActive",
            key: "isActive",
            className: "custom-header",
            render: (data, record) => {
                return record.isActive ? (
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: "green",
                            backgroundColor: "#e0f5f0",
                            borderColor: "lightgreen",
                            borderRadius: "0px",
                        }}
                    >
                        Active
                    </Tag>
                ) : (
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: "red",
                            backgroundColor: "#FFE1E1",
                            borderColor: "pink",
                            borderRadius: "0px",
                        }}
                    >
                        InActive
                    </Tag>
                );
            },
        },
        {
            title: "Created Time",
            dataIndex: "createdAt",
            key: "createdAt",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {ExtractDate(record.created_at)}.{ExtractTime(record.created_at)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "status",
            key: "status",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <div>
                        <Select
                            disabled={record.isRejected === "1" || record.isApproved === "1"}
                            placeholder={
                                record.isRejected === "1"
                                    ? "Rejected"
                                    : record.isApproved === "1"
                                        ? "Approved"
                                        : "Select "
                            }
                            style={{
                                width: 120,
                            }}
                            onChange={(value) => setwithdrawAction(record.id, value)}
                            value={action[record.id]}
                        >
                            <Select.Option value="approve">Approved</Select.Option>
                            <Select.Option value="reject">Rejected</Select.Option>
                        </Select>
                        {action[record.id] === "reject" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to reject this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("reject", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link">Submit</Button>
                            </Popconfirm>
                        )}
                        {action[record.id] === "approve" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to approve this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("approve", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link" size="small">
                                    Submit
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                );
            },
        },
    ];
    // const dataSource = [
    //   {
    //     key: "1",
    //     name: "Mike",
    //     age: 32,
    //     address: "10 Downing Street",
    //     date: "15 December, 2020",
    //   },
    //   {
    //     key: "2",
    //     name: "John",
    //     age: 42,
    //     address: "10 Downing Street",
    //     date: "15 December, 2020",
    //   },
    //   {
    //     key: "3",
    //     name: "John",
    //     age: 42,
    //     address: "10 Downing Street",
    //     date: "15 December, 2020",
    //   },
    //   {
    //     key: "4",
    //     name: "John",
    //     age: 42,
    //     address: "10 Downing Street",
    //     date: "15 December, 2020",
    //   },
    //   {
    //     key: "5",
    //     name: "John",
    //     age: 42,
    //     address: "10 Downing Street",
    //     date: "15 December, 2020",
    //   },
    // ];

    const columns = [
        // {
        //     title: "Image",
        //     dataIndex: "imageUrl",
        //     key: "imageUrl",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //                 </p>
        //             </>
        //         );
        //     },
        // },
        {
            title: "Name",
            dataIndex: "categoryName",
            key: "categoryName",
            className: "custom-header",
        },
        // {
        //     title: "Category Id",
        //     dataIndex: "category_id",
        //     key: "category_id",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     {text ? text : "-"}
        //                 </p>
        //             </>
        //         );
        //     },
        // },


        {
            title: "Created Time",
            dataIndex: "createdAt",
            key: "createdAt",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.created_at)}.{ExtractTime(record.created_at)}                        </p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "isActive",
            key: "isActive",
            render: (text) => {
                return (
                    <>
                        {text === "1" ? (
                            <Tag color="green">Success</Tag>
                        ) : text === "2" ? (
                            <Tag color="red">Failed</Tag>
                        ) : <Tag color="yellow">Pending</Tag>}
                    </>
                );
            },
        },
    ];
    return (
            <div className="p-0 md:p-4">

            {/* Card Wrapper */}
            <Card
                title="Category Data"
                bordered
                style={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                }}
                className="overflow-x-auto" // allows horizontal scroll on small screens
            >
                {/* Table */}
                <Table
                    bordered
                    loading={isLoading}
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    size="small"
                    rowClassName="text-gray-700"
                    className="history-table min-w-full" // ensures table stretches on larger screens
                    scroll={{ x: "max-content" }} // enables horizontal scroll for small screens
                />
            </Card>

            {/* Pagination */}
            <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
                <div className="text-sm text-gray-600">
                    {`Showing ${currentPage * 10 - 9} to ${currentPage * 10 > totalPages * 10 ? totalPages * 10 : currentPage * 10
                        } of ${totalPages * 10} items`}
                </div>
                <Pagination
                    total={totalPages * 10} // Assuming 10 items per page
                    onChange={handlePageChange}
                    defaultPageSize={10}
                    current={currentPage}
                    size="small"
                />
            </div>

            {/* Modal */}
            {openModal && <AddCategory isOpen={openModal} setIsOpen={setOpenModal} />}
        </div>

    );
};
export default CategoryList;
